import { MstMypageVideoKnowHowRequest } from '@/types/request';
import { fetchKnowHowVideo } from '../mstMypageVideoKnowHowEndpoint';
import { isArray } from 'lodash';
import axios from 'axios';

const VIMEO_URL_API = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/';

export type KnowHowDetailResponse = {
  knowhowId?: number;
  title?: string;
  knowhowUrlVideoMypageTag?: string;
  explanation?: string;
  explanationDetail?: string;
  dispOrder?: number;
  insertDate?: string;
  updateDate?: string;
  updateUsrId?: number;
  deleteFlg?: string;
  vimeoId?: string;
  thumbnailUrl?: string;
}

function getVimeoId(embedCode: string): string {
  if (!embedCode) {
    return '';
  }

  const regex = /video\/(\d+)\?h=(\w+)/;
  const matches = embedCode.match(regex);
  
  if (matches && matches.length >= 3) {
    return `${matches[1]}/${matches[2]}`;
  } else {
    return '';
  }
}

export const getVideoKnowHowListService = async () => {
  const params: MstMypageVideoKnowHowRequest = {
    type: 'multi',
    all: 'all'
  };
  const response = await fetchKnowHowVideo(params);
  if (isArray(response)) {
    const details = response as KnowHowDetailResponse[];
    details.forEach(detail => {
      detail.vimeoId = getVimeoId(detail.knowhowUrlVideoMypageTag || '').toString();

      // 最大100文字。101字目は「…」
      if (detail.explanation && detail.explanation.length > 100) {
        detail.explanation = detail.explanation.substring(0, 100) + '…';
      }
    });
    return details;
  }
  return null;
};

export const getVideoKnowHowDetailService = async (id: number) => {
  const params: MstMypageVideoKnowHowRequest = {
    type: 'one',
    id: id
  };
  const response = await fetchKnowHowVideo(params);
  if (isArray(response)) {
    const detail = response[0] as KnowHowDetailResponse;
    detail.vimeoId = getVimeoId(detail.knowhowUrlVideoMypageTag || '').toString();
    return detail;
  }
  return null;
};

export const loadVideoThumbnailService = async (vimeoId?: string) => {
  if (!vimeoId) return '';
  try {
    const response = await axios.get(VIMEO_URL_API + vimeoId);
    return response.data.thumbnail_url;
  } catch (error) {
    return '';
  }
};